export class ActionConstants {
	public static readonly ADD_ONE: string = 'ADD_ONE_TO_';
	public static readonly ADD_MANY: string = 'ADD_MANY_TO_';
	public static readonly UPDATE_ONE: string = 'UPDATE_ONE_IN_';
	public static readonly UPDATE_MANY: string = 'UPDATE_MANY_IN_';

	public static readonly REMOVE_ONE: string = 'REMOVE_ONE_FROM_';
	public static readonly SELECT_ONE: string = 'SELECT_ONE_FROM_';

	public static readonly LOAD_ONE: string = 'LOAD_ONE_';
	public static readonly LOAD_ALL: string = 'LOAD_ALL_';

	public static readonly NO_ACTION: string = 'NO_ACTION_';
}
